import { Profile } from "./../../screens/user-profile/client-data";
import { AccountService } from "./../../services/account.service";
import { ApiService } from "src/app/services/api.service";
import { UpdateOrderComponent } from "./../update-order/update-order.component";
import { ConfirmationComponent } from "./../confirmation/confirmation.component";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Order } from "src/app/models/order";
import { ColumnMode } from "@swimlane/ngx-datatable";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Account } from "src/app/screens/user-profile/client-data";
import {
  BroadcastEventListener,
  ISignalRConnection,
  SignalR,
  SignalRConfiguration,
} from "ng2-signalr";
import { UrlConstants } from "src/app/models/urlConstants";
import { OrderBuyComponent } from "../order-buy/order-buy.component";
import { FavService } from "src/app/services/fav.service";
import { SelectedOrderTradeComponent } from "../selected-order-trade/selected-order-trade.component";
import { ToastrService } from "ngx-toastr";
import { Sort } from "@angular/material/sort";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";

interface OMSFilterDto {
  relationCode;
  custodianCode;
  symbolCode;
  transactionType;
  orderNumber;
  marketId;
  fixStatus;
  fixStatusGroup;
  clientName;
  skip;
  take;
}

@Component({
  selector: "app-order-book",
  templateUrl: "./order-book.component.html",
  styleUrls: ["./order-book.component.scss"],
})
export class OrderBookComponent implements OnInit, OnDestroy {
  isOrdersLoading: boolean = false;
  @Input() isFromProfile = false;
  @Input() isHeaderRowElementsLayout: boolean = false;
  userOrders: Order[] = [];
  rows = [];
  selectedOrder: Order;
  filter: OMSFilterDto = {} as OMSFilterDto;
  searchUserOrders: Order[] = [];
  isDarkTheme: boolean;
  private destroy$ = new Subject<void>();
  dtOptions: {
    // scrollX: true,
    paging: boolean;
    searching: boolean;
    autoWidth: boolean;
    info: boolean;
    responsive: boolean;
    fixedHeader: boolean;
    select: boolean;
    ordering: boolean;
    // order: any[];
    // sorting: any[];
    columnDefs: any[];
  };

  mapFixStatusColor = new Map([
    ["0", "#007bff"],
    ["1", "#5aff55"],
    ["2", "darkgreen"],
    ["3", "yellow"],
    ["4", "#ff7200"],
    ["5", "#550eff"],
    ["6", "yellow"],
    ["8", "darkred"],
    ["9", "gray"],
    ["A", "yellow"],
    ["C", "darkred"],
    ["E", "yellow"],
    ["H", "darkred"],
    ["N", "darkred"],
    ["R", "yellow"],
    ["W", "yellow"],
    ["P", "yellow"],
    ["X", "yellow"],
    ["Y", "darkred"],
    ["Z", "cyan"],
  ]);

  ColumnMode = ColumnMode;
  accList: any;
  selectedAccount;
  @Input() acc;
  private ordersConnection: ISignalRConnection;
  backgrounColor: boolean;
  sortedData: Order[] = [];
  userOrderList;
  sortDirection;
  sortActive;
  switchedAccount: boolean = false;

  demandMethods = [
    {
      Id: "Written",
      Value: 0,
      NameE: "Written",
      NameA: "كتابة",
    },
    {
      Id: "Phone",
      Value: 1,
      NameE: "Phone",
      NameA: "تليفون",
    },
    {
      Id: "Fax",
      Value: 2,
      NameE: "Fax",
      NameA: "فاكس",
    },
    {
      Id: "Online",
      Value: 3,
      NameE: "Online",
      NameA: "اونلاين",
    },
    {
      Id: "Email",
      Value: 4,
      NameE: "Email",
      NameA: "بريد إلكتروني",
    },
  ];
isRequestLoading: any;

  demandEnum(value) {
    return this.demandMethods.find((item) => item.Value == value).NameA;
  }

  getBackgroundColor(fixStatusCode) {
    if (fixStatusCode) {
      let backgroundColor = this.mapFixStatusColor.get(fixStatusCode);
      return backgroundColor;
    }
  }
  getColor(fixStatusCode) {
    if (fixStatusCode) {
      let colorMatch = this.mapFixStatusColor.get(fixStatusCode);
      if (
        colorMatch == "white" ||
        colorMatch == "yellow" ||
        colorMatch == "#ff7200" ||
        colorMatch == "darkred" ||
        colorMatch == "darkgreen" ||
        colorMatch == "cyan" ||
        colorMatch == "#007bff"
      ) {
        return "white";
      }
    }
  }

  getTransaction(value) {
    if (value)
      return this.transactionIdValue.find((x) => x.value == value).viewValue;
    else return null;
  }
  getTiffFlag(value) {
    if (value != null)
      return this.tiffFlagValue.find((x) => x.value == value).viewValue;
    else return null;
  }
  getStatus(value) {
    if (value) return this.statusValue.find((x) => x.value == value).viewValue;
    else return null;
  }
  fixStatusValues = [
    {
      Id: "New",
      Value: "0",
      NameE: "New",
      NameA: "جديد",
    },
    {
      Id: "PartialFill",
      Value: "0",
      NameE: "Partial Fill",
      NameA: "تنفيذ جزئي",
    },
    {
      Id: "Fill",
      Value: "0",
      NameE: "Fill",
      NameA: "تنفيذ كلي",
    },
    {
      Id: "Cancelled",
      Value: "0",
      NameE: "Cancelled",
      NameA: "ملغى",
    },
    {
      Id: "Replace",
      Value: "0",
      NameE: "Replace",
      NameA: "معدل",
    },
    {
      Id: "PendingCancel",
      Value: "0",
      NameE: "Pending Cancel",
      NameA: "قيد الالغاء",
    },
    {
      Id: "Rejected",
      Value: "0",
      NameE: "Rejected",
      NameA: "مرفوض",
    },
    {
      Id: "Suspended",
      Value: "0",
      NameE: "Suspended",
      NameA: "موقوف",
    },
    {
      Id: "PendingNew",
      Value: "0",
      NameE: "Pending New",
      NameA: "قيد التسجيل",
    },
    {
      Id: "Expired",
      Value: "0",
      NameE: "Expired",
      NameA: "غير ساري",
    },
    {
      Id: "PendingReplace",
      Value: "0",
      NameE: "PendingReplace",
      NameA: "قيد التعديل",
    },
    {
      Id: "PartiallyCancelled",
      Value: "0",
      NameE: "Partially Cancelled",
      NameA: "ملغى جزئيا",
    },
    {
      Id: "PendingMCSD",
      Value: "0",
      NameE: "Pending MCSD",
      NameA: "قيد التسجيل",
    },
    {
      Id: "RejectedByMCSD",
      Value: "0",
      NameE: "Rejected by MCSD",
      NameA: "مرفوض من المقاصة",
    },
    {
      Id: "ApprovedByMCSD",
      Value: "0",
      NameE: "Approved by MCSD",
      NameA: "مقبول من المقاصة",
    },
    {
      Id: "NotApprovedByMCSD",
      Value: "0",
      NameE: "Not approved by MCSD",
      NameA: "غير مقبول من المقاصة",
    },
    {
      Id: "InternalError",
      Value: "0",
      NameE: "Internal Error",
      NameA: "خطأ داخلي",
    },
    {
      Id: "ExternalError",
      Value: "0",
      NameE: "External Error",
      NameA: "خطأ خارجي",
    },
    {
      Id: "TradeCancelled",
      Value: "0",
      NameE: "Trade Cancelled",
      NameA: "تنفيذ ملغي",
    },
    {
      Id: "None",
      Value: "0",
      NameE: "None",
      NameA: "لا يوجد",
    },
    {
      Id: "Pending",
      Value: "0",
      NameE: "Pending",
      NameA: "جاري الإرسال",
    },
  ];
  statusValue = [
    {
      value: 1,
      viewValue:
        this.translate.currentLang == "en" ? "LocalNew" : "جديد داخليا",
    },
    {
      value: 2,
      viewValue:
        this.translate.currentLang == "en" ? "LocalUpdate" : "تعديل داخلي",
    },
    {
      value: 3,
      viewValue:
        this.translate.currentLang == "en" ? "LocalCancel" : "إلغاء داخلي",
    },
    {
      value: 4,
      viewValue: this.translate.currentLang == "en" ? "Divided" : "مقسم",
    },
    {
      value: 5,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitNew"
          : "انتظار إرسال البورصة",
    },
    {
      value: 6,
      viewValue: this.translate.currentLang == "en" ? "FIXNew" : "تم الإرسال",
    },
    {
      value: 7,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitUpdate"
          : "انتظار إرسال التعديل",
    },
    {
      value: 8,
      viewValue:
        this.translate.currentLang == "en" ? "FIXUpdate" : "تم التعديل",
    },
    {
      value: 9,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitCancel"
          : "انتظار إرسال الإلغاء",
    },
    {
      value: 10,
      viewValue: this.translate.currentLang == "en" ? "FIXCancel" : "ملغى",
    },
    {
      value: 11,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitSuspend"
          : "انتظار إرسال الإيقاف",
    },
    {
      value: 12,
      viewValue: this.translate.currentLang == "en" ? "FIXSuspend" : "موقوف",
    },
    {
      value: 13,
      viewValue:
        this.translate.currentLang == "en"
          ? "UpdateDividedNoCascade"
          : "تعدبل تقسيم بدون توزيع",
    },
    {
      value: 14,
      viewValue:
        this.translate.currentLang == "en"
          ? "UpdateDividedCascade"
          : "تعديل تقسيم بالتوزيع",
    },
    {
      value: 15,
      viewValue: this.translate.currentLang == "en" ? "Automatic" : "تلقائي",
    },
    {
      value: 16,
      viewValue:
        this.translate.currentLang == "en" ? "FixPrivate" : "FixPrivate",
    },
    {
      value: 17,
      viewValue: this.translate.currentLang == "en" ? "FixPublic" : "FixPublic",
    },
    {
      value: 18,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitApprove"
          : "إنتظار الإعتماد للإرسال",
    },
    {
      value: 20,
      viewValue: this.translate.currentLang == "en" ? "HubNew" : "HubNew",
    },
    {
      value: 21,
      viewValue: this.translate.currentLang == "en" ? "HubUpdate" : "HubUpdate",
    },
    {
      value: 22,
      viewValue: this.translate.currentLang == "en" ? "HubCancel" : "HubCancel",
    },
    {
      value: 23,
      viewValue:
        this.translate.currentLang == "en" ? "HubRejected" : "HubRejected",
    },
    {
      value: 24,
      viewValue: this.translate.currentLang == "en" ? "FixRejected" : "رفض",
    },
    {
      value: 25,
      viewValue:
        this.translate.currentLang == "en" ? "FixRupdate" : "FixRupdate",
    },
    {
      value: 26,
      viewValue:
        this.translate.currentLang == "en" ? "FixExpired" : "FixExpired",
    },
    {
      value: 27,
      viewValue:
        this.translate.currentLang == "en" ? "DisApproved" : "رفض ائتمان",
    },
  ];
  tiffFlagValue = [
    { value: 0, viewValue: "Day" },
    { value: 1, viewValue: "Good Till Cancel" },
    { value: 6, viewValue: "Good Till Date" },
    { value: 3, viewValue: "Immediate" },
  ];
  transactionIdValue = [
    {
      value: 1,
      viewValue: this.translate.currentLang == "en" ? "Buy" : "شراء",
    },
    {
      value: 2,
      viewValue: this.translate.currentLang == "en" ? "Sell" : "بيع",
    },
    {
      value: 3,
      viewValue:
        this.translate.currentLang == "en" ? "Sell Same Day" : "بيع نفس اليوم",
    },
    {
      value: 4,
      viewValue:
        this.translate.currentLang == "en" ? "Buy Same Day" : "شراء نفس اليوم",
    },
    {
      value: 5,
      viewValue: this.translate.currentLang == "en" ? "Sell T+1" : "بيع t+1",
    },
    {
      value: 6,
      viewValue: this.translate.currentLang == "en" ? "Buy T+1" : "شراء t+1",
    },
  ];
  priceTypeValue = [
    {
      value: 1,
      viewValue: this.translate.currentLang == "en" ? "Buy" : "شراء",
    },
    {
      value: 2,
      viewValue: this.translate.currentLang == "en" ? "Sell" : "بيع",
    },
  ];

  constructor(
    public translate: TranslateService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private _service: ApiService,
    private signalR: SignalR,
    private toastr: ToastrService,
    public accService: AccountService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnDestroy() {
    if (this.ordersConnection) this.ordersConnection.stop();
    this.destroy$.next();
    this.destroy$.complete();
  }

  connectOrdersSignalr() {
    let config: SignalRConfiguration = new SignalRConfiguration();
    config.url = UrlConstants.backofficeUrl;
    config.hubName = "ordersHub";
    config.logging = false;

    this.accService.saveUserProfile(this.selectedAccount);
    let currentProfile = JSON.parse(
      localStorage.getItem("userProfile")
    ) as Profile;
    const selectedAccountObject = this.accList?.find(acc => acc.relationCode === this.selectedAccount);
    if (selectedAccountObject != undefined) {
      this.signalR.connect(config).then((res) => {
        this.ordersConnection = res;
        this.ordersConnection.invoke("JoinGroup", selectedAccountObject?.ExchangeCode);

        let method = new BroadcastEventListener<any>("sendOrders");

        this.ordersConnection.listen(method);
        method.subscribe((updateList) => {
          setTimeout(() => {
            updateList.forEach((order) => {
              let index;
              if (this.userOrders != undefined && this.userOrders?.length > 0) {
                index = this.userOrders
                  .map((e) => e.OrderNumber)
                  .indexOf(order.OrderNumber);
              } else index = -1;
              if (index >= 0) {
                this.userOrders[index].OrgQty = order.OrgQty;
                this.userOrders[index].OrgPrice = order.OrgPrice;
                this.userOrders[index].OrderStatus = order.OrderStatus;
                this.userOrders[index].FixStatus = order.FixStatus;
                this.userOrders[index].LastUpdateDate = order.LastUpdateDate;
                this.userOrders[index].TradedQty = order.TradedQty;
                this.userOrders[index].IsMarketPrice = order.IsMarketPrice;
                this.userOrders[index].TiffDate = order.TiffDate;
                this.userOrders[index].TiffFlag = order.TiffFlag;
                this.userOrders[index].FixStatusEn = order.FixStatusEn;
                this.userOrders[index].FixStatusAr = order.FixStatusAr;
                this.userOrders[index].FixVal = order.FixVal;
                this.userOrders[index].ISMSCDSucceeded = order.ISMSCDSucceeded;
                this.userOrders[index].ISMSCDBook = order.ISMSCDBook;
                this.userOrders[index].Remark = order.Remark;

                this.userOrders[index].isUpdate = true;
              } else if (index == -1) this.getOrders();
            });
            // this.fetchOrders();
          }, 500);

          // updateList.forEach((update) => {
          //   let isNewOrder = this.userOrders.findIndex((order) => {
          //     return order.OrderNumber == update.OrderNumber;
          //   });

          //   if (isNewOrder) this.userOrders.unshift(update);
          //   else this.userOrders[isNewOrder] = update;
          // });
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.acc && changes.acc != null) {
      if (!this.acc) {
        this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
        this.selectedAccount = this.accList[0].relationCode;
      } else {
        this.selectedAccount = this.acc;
        if (this.ordersConnection) {
          this.ordersConnection.stop();
          this.switchedAccount = true;
        }

      }
      this.getOrders();
    }
  }

  ngOnInit(): void {
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
    this.isDarkTheme = localStorage.getItem("darktheme") == "dark" ? true : false;
    this.dtOptions = {
      // scrollX: true,
      paging: false,
      searching: false,
      autoWidth: true,
      info: false,
      responsive: true,
      fixedHeader: true,
      select: true,
      ordering: false,
      // order: [[2, "desc"]],
      // sorting: [],
      columnDefs: [{ type: "date", targets: [2] }],

      // ajax: (dataTablesParameters: any, callback) => {
      //   this.fetchEGX("EGX30").subscribe((res) => {
      //     this.isCompaniesLoading = false;
      //     this.companies = res as CompanyList[];
      //     this.WindowResize();

      //     callback({
      //       recordsTotal: this.companies.length,
      //       data: [],
      //     });
      //   });
      // },
    };
    if (!this.acc) {
      this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
      this.selectedAccount = this.accList[0].relationCode;
    } else {
      this.selectedAccount = this.acc;
    }
  }

  ngAfterContentInit() {
    this.getOrders();
  }

  updateOrder(row) {
    this.isRequestLoading = true;
    this.selectedOrder = row;
    const dialogRef = this.dialog.open(UpdateOrderComponent, {
      panelClass: "custom-dialog-container",
      data: { order: row, type: 0, selectedAccount: this.selectedAccount },
      width: "500px",
    });
    this.isRequestLoading = false;
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed == true) {
        this.toastr.info("", this.translate.instant("order-update-success"), {
          timeOut: 15000,
          positionClass: "toast-bottom-center",
          closeButton: true,
        });
      } else {
        if (confirmed != null)
          this.toastr?.error(
            this.translate?.instant(confirmed),
            this.translate?.instant("error-msg"),
            {
              timeOut: 15000,
              positionClass: "toast-bottom-center",
              closeButton: true,
            }
          );
      }
    });
  }

  deleteOrder(row) {
    this.selectedOrder = row;

    const dialogRef = this.dialog.open(ConfirmationComponent, {
      data: {
        message:
          this.translate.instant("confirm-order-deletion") +
          this.selectedOrder.OrderNumber +
          "\n" +
          this.translate.instant("confirm-order-deletion-name") +
          " " +
          (this.translate.currentLang == "en"
            ? this.selectedOrder.SymbolNameEn
            : this.selectedOrder.SymbolNameAr) +
          " " +
          this.translate.instant("confirm-order-deletion-type") +
          " " +
          (this.translate.currentLang == "ar"
            ? this.selectedOrder.TransactionTypeAr
            : this.selectedOrder.TransactionTypeEn) +
          (this.translate.currentLang == "en" ? "?" : "؟"),
        //   this.translate.instant("confirm-order-deletion-name") +
        //   this.translate.currentLang ==
        // "ar"
        //   ? this.selectedOrder.TransactionTypeAr
        //   : this.selectedOrder.TransactionTypeEn,
        buttonText: {
          ok: this.translate.instant("submit"),
          cancel: this.translate.instant("cancel"),
        },
      },
      width: "400px",
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this._service.cancelOrder(row.OrderNumber).subscribe(
          (res) => {
            if (res) {
              this.toastr.info(
                "",
                this.translate.instant("order-cancel-success"),
                {
                  timeOut: 15000,
                  positionClass: "toast-bottom-center",
                  closeButton: true,
                }
              );
            }
          },
          (err) => {
            this.toastr.error("", this.translate.instant("error-msg"), {
              timeOut: 15000,
              positionClass: "toast-bottom-center",
              closeButton: true,
            });
          }
        );
      }
    });
  }

  isWaitingMSCD(order: Order) {
    return order.ISMSCDBook && !order.ISMSCDSucceeded && order.FixVal == "2";
  }

  remainingQty(row: Order) {
    let result = row.OrgQty - row.TradedQty;
    if (result < 0) return 0;
    else return result;
  }

  orderDoubleClicked(order: Order) {
    if (this.CanBeFIXUpdated(order)) this.updateOrder(order);
  }
  CanBeFIXUpdated(order: Order) {
    if (order.FixStatus != null) {
      ``;
      if (
        (order.FixStatus == "0" ||
          order.FixStatus == "1" ||
          order.FixStatus == "5" ||
          order.FixStatus == "A" ||
          order.FixStatus == "E" ||
          order.FixStatus == "X" ||
          order.FixStatus == "Z" ||
          order.FixStatus == "H" ||
          order.FixStatus == "W")
        && (
          order.OrderStatus != 7 &&
          order.OrderStatus != 9 &&
          order.OrderStatus != 11
        )

      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        order.OrderStatus == 5 ||
        order.OrderStatus == 6 ||
        order.OrderStatus == 8
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
  getOrders() {

    this.userOrders = [];

    this.filter.skip = 0;
    this.filter.take = this.isFromProfile ? 1000 : 10;

    this.isOrdersLoading = true;

    this._service.fetchOrders(this.selectedAccount, 0)
    .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.cdr.detectChanges();
            this.isOrdersLoading = false;
          })
        )
    .subscribe((res) => {
      this.isOrdersLoading = false;
      this.userOrders = res as Order[];

    });
    if (!this.ordersConnection) {
      this.connectOrdersSignalr();
    }
    if (this.switchedAccount) {
      this.connectOrdersSignalr();
      this.switchedAccount = false;
    }
  }
  newOrder() {
    this.isOrdersLoading = false;
    const dialogRef = this.dialog.open(OrderBuyComponent, {
      disableClose: true,
      panelClass: "order-dialog-container",
      data: { type: 0, currentUser: this.selectedAccount },
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });
    this.isOrdersLoading = false;
    dialogRef.afterClosed().subscribe((result) => {
      this.getOrders();
    });
  }
  viewOrder(orderNum) {
    const dialogRef = this.dialog.open(SelectedOrderTradeComponent, {
      panelClass: "custom-dialog-container",
      data: { order: orderNum },
      width: "464px",
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  setFilter(filter) {
    this.isOrdersLoading = true;
    this._service.fetchOrders(this.selectedAccount, filter)
    .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.isOrdersLoading = false;
            this.cdr.detectChanges();
          })
        )
    .subscribe((res) => {
      this.isOrdersLoading = false;
      this.userOrders = res as Order[];
      if (!this.ordersConnection) this.connectOrdersSignalr();
    });
  }

  get userOrdersData() {
    if (this.searchUserOrders?.length > 0) {
      if (JSON.stringify(this.searchUserOrders[0]) === "{}") {
        return [];
      } else {
        if (this.sortedData?.length > 0) {
          this.userOrderList = this.sortAfterSearch(this.searchUserOrders);
        } else {
          this.userOrderList = this.searchUserOrders;
        }
        // return this.searchUserOrders;
      }
    } else if (this.userOrders?.length > 0) {
      if (this.sortedData?.length > 0) {
        this.userOrderList = this.sortAfterSearch(this.userOrders);
      } else {
        this.userOrderList = this.userOrders;
      }
      // return this.userOrders;
    } else {
      this.userOrderList = null;
    }
    return this.userOrderList;
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    if (val != "") {
      let temp;
      temp = this.userOrders;
      temp =
        temp.filter(function (d) {
          return (
            d.SymbolNameEn.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            d.SymbolNameAr.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            (d.OrderNumber + "").indexOf(val.toLocaleLowerCase()) > -1 ||
            d.Reuters.toLocaleLowerCase().includes(val.toLocaleLowerCase()) ||
            d.SymbolShortNameAr.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            d.SymbolShortNameEn.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            )
          );
        }) || [];
      this.searchUserOrders = temp.length > 0 ? temp : [{}];
    } else this.searchUserOrders = this.userOrders;
  }

  sortAfterSearch(list) {
    const data = list.slice();

    if (!this.sortActive || this.sortDirection === '') {
      this.userOrderList = data;
      this.sortedData = null;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = this.sortDirection === 'asc';
      const isDec = this.sortDirection !== 'asc';
      switch (this.sortActive) {
        case 'symbol':
          return this.compare(this.translate.currentLang == "ar" ? a.SymbolShortNameAr : a.SymbolShortNameEn, this.translate.currentLang == "ar" ? b.SymbolShortNameAr : b.SymbolShortNameEn, isAsc);
        case 'order':
          return this.compare(a.OrderNumber, b.OrderNumber, isAsc);
        case 'last-update':
          return this.compare(a.LastUpdateDate, b.LastUpdateDate, isDec);
        case 'remaining-qty':
          return this.compare(a.OrgQty - a.TradedQty < 0 ? 0 : a.OrgQty - a.TradedQty, b.OrgQty - b.TradedQty < 0 ? 0 : b.OrgQty - b.TradedQty, isAsc);
        case 'qty':
          return this.compare(a.OrgQty, b.OrgQty, isAsc);
        case 'price':
          return this.compare(a.OrgPrice, b.OrgPrice, isAsc);
        case 'filled':
          return this.compare(a.TradedQty, b.TradedQty, isAsc);
        default:
          return 0;
      }
    });
    return this.sortedData;
  }

  sortData(sort: Sort) {

    this.sortDirection = sort.direction;
    this.sortActive = sort.active;
    const data = this.userOrderList?.slice();

    if (!sort.active || sort.direction === '') {
      this.userOrderList = data;
      this.sortedData = null;
      return;
    }


    this.sortedData = data?.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      const isDec = this.sortDirection !== 'asc';
      switch (sort.active) {
        case 'symbol':
          return this.compare(this.translate.currentLang == "ar" ? a.SymbolShortNameAr : a.SymbolShortNameEn, this.translate.currentLang == "ar" ? b.SymbolShortNameAr : b.SymbolShortNameEn, isAsc);
        case 'order':
          return this.compare(a.OrderNumber, b.OrderNumber, isAsc);
        case 'last-update':
          return this.compare(a.LastUpdateDate, b.LastUpdateDate, isDec);
        case 'remaining-qty':
          return this.compare(a.OrgQty - a.TradedQty < 0 ? 0 : a.OrgQty - a.TradedQty, b.OrgQty - b.TradedQty < 0 ? 0 : b.OrgQty - b.TradedQty, isAsc);
        case 'qty':
          return this.compare(a.OrgQty, b.OrgQty, isAsc);
        case 'price':
          return this.compare(a.OrgPrice, b.OrgPrice, isAsc);
        case 'filled':
          return this.compare(a.TradedQty, b.TradedQty, isAsc);
        default:
          return 0;
      }
    });
  }


  compare(a: number | string, b: number | string, isAsc: boolean) {
    var aValue = (typeof a === 'string') ? a.toLowerCase() : a;
    var bValue = (typeof b === 'string') ? b.toLowerCase() : b;
    return (aValue < bValue ? -1 : 1) * (isAsc ? 1 : -1);
  }

  async cloneOrder(qty: number, price: number, companySymbol: string, isSell: boolean) {
    try {
      this.isRequestLoading = true;
      // Assuming you have a method to get the current user data
      const currentUser = await this.getCurrentUserData(this.selectedAccount);

      // Open the dialog with the retrieved user data
      const dialogRef = this.dialog.open(OrderBuyComponent, {
        disableClose: true,
        panelClass: "order-dialog-container",
        data: {
          currentUser: currentUser,
          symbol: companySymbol,
          type: !isSell,
          price: price,
          qty: qty,
        },
        direction: this.translate.currentLang === "ar" ? "rtl" : "ltr",
      });
      this.isRequestLoading = false;
      // Handle the dialog result
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          // Handle the result if necessary
        }
      });
    } catch (error) {
      // Optionally show a notification to the user
      this.toastr.error("Failed to retrieve user data.");
    }
  }
  private async getCurrentUserData(account: any): Promise<Account> {
    // Replace with your actual data fetching logic
    return new Promise((resolve, reject) => {
      // Simulating an asynchronous operation
      setTimeout(() => {
        if (account) {
          resolve(account); // Mock data resolution
        } else {
          reject("No account found");
        }
      }, 1000); // Simulate a delay
    });
  }
}
